module.exports = __webpack_public_path__ + "img/img_phone_list.4783178e.png";